import api from '.'

export const participantResources = {
  list (trialId, success, fail) {
    api.authenticatedRequest('GET', `/trials/${trialId}/participantResources`, null, success, fail)
  },
  create (trialId, data, success, fail) {
    api.authenticatedRequest('POST', `/trials/${trialId}/participantResources`, data, success, fail)
  },
  update (trialId, resourceId, data, success, fail) {
    api.authenticatedRequest('PUT', `/trials/${trialId}/participantResources/${resourceId}`, data, success, fail)
  },
  delete (trialId, resourceId, success, fail) {
    api.authenticatedRequest('DELETE', `/trials/${trialId}/participantResources/${resourceId}`, null, success, fail)
  }
}
